import financepmIcon from "../assets/apps/financepm-icon.webp";
import financepm1 from "../assets/apps/financepm-1.webp";
import financepm2 from "../assets/apps/financepm-2.webp";
import financepm3 from "../assets/apps/financepm-3.webp";
import financepmRu1 from "../assets/apps/financepm-ru-1.webp";
import financepmRu2 from "../assets/apps/financepm-ru-2.webp";
import financepmRu3 from "../assets/apps/financepm-ru-3.webp";
import eficsIcon from "../assets/apps/efics-icon.webp";
import efics1 from "../assets/apps/efics-1.webp";
import efics2 from "../assets/apps/efics-2.webp";
import efics3 from "../assets/apps/efics-3.webp";
import eficsRu1 from "../assets/apps/efics-ru-1.webp";
import eficsRu2 from "../assets/apps/efics-ru-2.webp";
import eficsRu3 from "../assets/apps/efics-ru-3.webp";

const appsContent = [
  {
    key: "financepm",
    name: {
      en: "Expense Tracker - FinancePM",
      ru: "Учёт расходов и доходов"
    },
    developer: "URAMAKS.com",
    rating: "4.8",
    installs: "1M+",
    playUrl: "https://play.google.com/store/apps/details?id=com.finperssaver",
    iconUrl: financepmIcon,
    screenshots: {
      en: [financepm1, financepm2, financepm3],
      ru: [financepmRu1, financepmRu2, financepmRu3]
    },
    descriptions: {
      ru: "Удобный трекер расходов и бюджета с отчетами, категориями, синхронизацией и управлением долгами.",
      en: "A modern expense and budget tracker with reports, categories, cloud sync, and debt management tools."
    },
    reviews: [
      {
        author: "Anna K.",
        rating: 5,
        ru: "Лучшее приложение для учёта расходов из тех, что я пробовала. Категории, отчёты и синхронизация между телефоном и планшетом работают идеально. Наконец-то вижу, куда уходят деньги.",
        en: "The best expense tracker I've tried. Categories, reports and sync between my phone and tablet work flawlessly. I finally see where my money goes."
      },
      {
        author: "Dmitry P.",
        rating: 5,
        ru: "Пользуюсь больше года. Удобный ввод операций, наглядные графики по месяцам и управление долгами — всё в одном месте. Интерфейс чистый и быстрый.",
        en: "I've been using it for over a year. Quick transaction entry, clear monthly charts and debt tracking — all in one place. The UI is clean and fast."
      }
    ]
  },
  {
    key: "efics",
    name: {
      en: "Bill tracker - Efics",
      ru: "Учет финансов - Efics"
    },
    developer: "URAMAKS.com",
    rating: "4.6",
    installs: "10K+",
    playUrl: "https://play.google.com/store/apps/details?id=com.efics",
    iconUrl: eficsIcon,
    screenshots: {
      en: [efics1, efics2, efics3],
      ru: [eficsRu1, eficsRu2, eficsRu3]
    },
    descriptions: {
      ru: "Приложение для учета доходов и расходов с синхронизацией, шаблонами операций, SMS-парсингом и категориями.",
      en: "A bill and finance tracker with sync, operation templates, SMS parsing, and category-based accounting."
    },
    reviews: [
      {
        author: "Marina V.",
        rating: 5,
        ru: "Отлично подходит для семейного бюджета. Веду доходы и расходы вдвоём с мужем, всё синхронизируется. Шаблоны операций реально экономят время.",
        en: "Great for our family budget. My husband and I track income and expenses together and everything syncs. The operation templates really save time."
      },
      {
        author: "Sergey N.",
        rating: 4,
        ru: "Автоматический разбор SMS от банка — лучшая фича, не нужно вводить каждую покупку вручную. Команда быстро реагирует на отзывы и регулярно выпускает обновления.",
        en: "Automatic parsing of bank SMS is the best feature — no need to enter every purchase by hand. The team responds to feedback fast and ships updates regularly."
      }
    ]
  }
];

import { resolveContentLanguage } from "../i18n/languages";

function getLocalizedValue(value, language = "en") {
  if (!value || typeof value === "string") {
    return value || "";
  }

  const availableKeys = Object.keys(value);
  const lang = resolveContentLanguage(language, availableKeys);
  return value[lang] || value.en || "";
}

export function getAppName(app, language = "en") {
  return getLocalizedValue(app.name, language);
}

export function getAppScreenshots(app, language = "en") {
  if (Array.isArray(app.screenshots)) {
    return app.screenshots;
  }

  const availableKeys = Object.keys(app.screenshots || {});
  const lang = resolveContentLanguage(language, availableKeys);
  return app.screenshots[lang] || app.screenshots.en || [];
}

export function getAppDescription(app, language = "en") {
  return getLocalizedValue(app.descriptions, language);
}

export function getReviewText(review, language = "en") {
  return getLocalizedValue(review, language);
}

export default appsContent;
